import React, {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';

import {useMovePage} from '../../hooks/useMovePage';
import styles from './styles/dropdown.module.css';

import {ReactComponent as ArrowDownImg} from '../../assets/dropDown/arrow-down.svg';
import {ReactComponent as ArrowUpImg} from '../../assets/dropDown/arrow-up.svg';

export default function Dropdown() {
    const movePage = useMovePage();

    const location = useLocation();

    const [openDropdown, setOpenDropdown] = useState(false);
    const [selectedItem, setSelectedItem] = useState('주요 기능');

    const itemMap = [
        { name: '채팅 기능', value: '/service/chat' },
        { name: '관리자 기능', value: '/service/admin' }
    ];

    const toggleDropdown = () => {
        setOpenDropdown(!openDropdown);
    };

    const selectItem = (item) => {
        setSelectedItem(item.name);
        setOpenDropdown(false);

        movePage(item.value);
    };

    useEffect(() => {
        if (location.pathname === '/service/chat') {
            setSelectedItem('채팅 기능');
        }

        if (location.pathname === '/service/admin') {
            setSelectedItem('관리자 기능');
        }
        
        if (location.pathname === '/' || location.pathname === '/about') {
            setSelectedItem('주요 기능');
        }

        setOpenDropdown(false);
    }, [location]);

    return (
        <div className={styles.wrapper}>
            <button onClick={toggleDropdown}>
                <p>{selectedItem}</p>
                {openDropdown ? <ArrowUpImg /> : <ArrowDownImg />}
            </button>
            {openDropdown &&
                <ul>
                    {itemMap.map((item, index) => (
                        <li key={index}
                            onClick={() => selectItem(item)}
                        >
                            {item.name}
                        </li>
                    ))}
                </ul>
            }
        </div>
    );
}
